<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Aprovação" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link to="/aprovacoes-compras">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && aprovacao">
      <v-card v-if="!isModalView"
              class="rounded-card card-shadow">
        <v-card-text class="text--primary">
          <px-aprovacao-compra-detalhes-dados-basicos :aprovacao="aprovacao" @update="onUpdate"/>
        </v-card-text>
      </v-card>
      <px-aprovacao-compra-detalhes-dados-basicos v-if="isModalView"
                                                  :aprovacao="aprovacao"
                                                  @update="onUpdate"/>
      <px-aprovacao-compra-detalhes-produtos :aprovacao="aprovacao" @update="onUpdate"/>
      <px-aprovacao-compra-detalhes-links :aprovacao="aprovacao"/>
      <px-aprovacao-compra-detalhes-mensagens-personalizadas v-if="hasMensagensPersonalizadas"
                                                             :aprovacao="aprovacao"/>
    </div>
  </div>
</template>

<script>
import AprovacaoCompraService from '@/modules/aprovacao-compra/aprovacao-compra-service';
import AprovacaoCompraDetalhesDadosBasicos
  from '@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhesDadosBasicos.vue';
import AprovacaoCompraDetalhesProdutos
  from '@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhesProdutos.vue';
import AprovacaoCompraDetalhesLinks
  from '@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhesLinks.vue';
import AprovacaoCompraDetalhesMensagensPersonalizadas from './AprovacaoCompraDetalhesMensagensPersonalizadas.vue';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    aprovacaoIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      id: null,
      aprovacao: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Aprovações', to: '/aprovacoes' },
        { text: 'Detalhes' },
      ],
    };
  },
  computed: {
    hasMensagensPersonalizadas() {
      return this.aprovacao.mensagensPersonalizadas
        && this.aprovacao.mensagensPersonalizadas.length;
    },
  },
  methods: {
    getAprovacao() {
      this.loading = true;
      AprovacaoCompraService.get(this.id)
        .then((response) => {
          this.aprovacao = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
      this.getAprovacao();
    },
  },
  created() {
    this.id = this.aprovacaoIdProp || this.$route.params.id;
    this.getAprovacao();
  },
  components: {
    pxAprovacaoCompraDetalhesDadosBasicos: AprovacaoCompraDetalhesDadosBasicos,
    pxAprovacaoCompraDetalhesProdutos: AprovacaoCompraDetalhesProdutos,
    pxAprovacaoCompraDetalhesLinks: AprovacaoCompraDetalhesLinks,
    pxAprovacaoCompraDetalhesMensagensPersonalizadas:
      AprovacaoCompraDetalhesMensagensPersonalizadas,
  },
};
</script>
